<div class="action-setup-container">
  <!-- Available Actions List -->
  <div class="available-actions-section" *ngIf="availableActions && availableActions.length > 0">
    <h3 class="section-title">Configured Actions</h3>
    <div class="actions-list">
      <div class="action-item" *ngFor="let action of availableActions; let i = index">
        <div class="action-info">
          <span class="action-name">{{ action.name || action.action_id }}</span>
        </div>
        <div class="action-actions">
          <button type="button" class="btn-icon" (click)="updateAction(action.action_id, i); $event.stopPropagation()" title="Edit">
            <svg class="icon">
              <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
            </svg>
          </button>
          <button type="button" [disabled]="readonly" class="btn-icon btn-danger" (click)="deleteAction(i)" title="Delete">
            <svg class="icon">
              <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="action-form-container">
     <!-- Action Selection -->
  <div class="action-selection-section">
    <div class="form-group">
      <label class="form-label">Select Action</label>
      <div class="custom-dropdown" [class.open]="isDropdownOpen('action')" [class.has-value]="!!selectedActionId">
        <button type="button" [disabled]="readonly" class="custom-dropdown-toggle" (click)="toggleDropdown('action', $event)">
          <span class="custom-dropdown-label" [class.is-placeholder]="!selectedActionId">{{ getDropdownLabel(getActionDropdownOptions(), selectedActionId, 'Select an action') }}</span>
          <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
        </button>
        <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('action')">
          <li class="custom-dropdown-item custom-dropdown-item--placeholder" [class.active]="!selectedActionId"
            (click)="onCustomSelect('action', '', 'action'); $event.stopPropagation()">
            Select an action
          </li>
          <li class="custom-dropdown-item" *ngFor="let action of getActionDropdownOptions()"
            [class.active]="selectedActionId === action.id"
            (click)="onCustomSelect('action', action.id, 'action'); $event.stopPropagation()">
            <span class="custom-dropdown-item-text">{{ action.name }}</span>
            <span class="custom-dropdown-check" *ngIf="selectedActionId === action.id" aria-hidden="true">✓</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Action Configuration Form -->
  <div class="action-config-section" *ngIf="selectedActionId">
    <div *ngIf="isAPIRequest">
      <div class="form-group">
        <label class="form-label">Description</label>
        <input type="text" [disabled]="readonly" class="form-input" [(ngModel)]="requestOptions.log_text" placeholder="Description">
      </div>
      <div class="api-request-section">
        <div class="custom-dropdown request-type-dropdown" [class.open]="isDropdownOpen('requestType')">
          <button type="button" [disabled]="readonly" class="custom-dropdown-toggle" (click)="toggleDropdown('requestType', $event)">
            <span class="custom-dropdown-label" [class.is-placeholder]="!requestOptions.requestType">{{ getDropdownLabel(requestTypeOptions, requestOptions.requestType, 'Method') }}</span>
            <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
          </button>
          <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('requestType')">
            <li class="custom-dropdown-item" *ngFor="let method of requestTypeOptions"
              [class.active]="requestOptions.requestType === method.id"
              (click)="onCustomSelect('requestType', method.id, 'requestType'); $event.stopPropagation()">
              {{ method.name }}
            </li>
          </ul>
        </div>
        <input type="text" [disabled]="readonly" [(ngModel)]="requestOptions.requestUrl" placeholder="https://api.example.com/endpoint">
      </div>

      <!-- Retry Toggle -->
      <div class="form-group switch-group">
        <span class="switch-label">Enable Retry</span>
        <div class="property-toggle">
          <label class="switch">
            <input type="checkbox" [disabled]="readonly" [(ngModel)]="retry">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div class="form-group switch-group">
        <span class="switch-label">Authentication Required</span>
        <div class="property-toggle">
          <label class="switch">
            <input type="checkbox" [disabled]="readonly" [(ngModel)]="authRequired" (ngModelChange)="onAuthRequiredChange($event)">
            <span class="slider round"></span>
          </label>
        </div>
      </div>

      <!-- Tabs Navigation -->
      <div class="tabs-container">
        <button type="button" class="tab-button" [class.active]="activeTab === 'parameters'"
          (click)="activeTab = 'parameters'">
          Parameters
        </button>
        <button type="button" *ngIf="authRequired" class="tab-button" [class.active]="activeTab === 'authorization'"
          (click)="activeTab = 'authorization'">
          Authorization
        </button>
        <button type="button" class="tab-button" [class.active]="activeTab === 'response'"
          (click)="activeTab = 'response'">
          Response
        </button>
      </div>

      <!-- API Request Form -->
      <div class="tab-content">
        <!-- Parameters Tab -->
        <div class="tab-panel" *ngIf="activeTab === 'parameters'">
          <!-- Parameter Input Toggle -->
          <div class="parameter-view-toggle">
            <button type="button"  class="toggle-btn" [class.active]="parameterKeyPair"
              (click)="toggleParameterView('keyPair')">
              Key-Value Pairs
            </button>
            <button type="button" class="toggle-btn" [class.active]="!parameterKeyPair"
              (click)="toggleParameterView('json')">
              JSON
            </button>
          </div>

          <!-- Key-Value Pairs View -->
          <div *ngIf="parameterKeyPair" class="key-value-section">
            <table class="key-value-table">
              <thead>
                <tr>
                  <th class="key-col">Key</th>
                  <th class="value-col">Value</th>
                  <th class="actions-col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let config of keyPairConfig; let i = index">
                  <td class="key-col">
                    <input type="text" [disabled]="readonly" class="form-input key-input" [value]="config.key || ''"
                      (input)="onKeyPairChange(i, 'key', $any($event.target).value)" placeholder="Key">
                  </td>
                  <td class="value-col">
                    <input type="text" [disabled]="readonly" class="form-input value-input" [value]="config.value || ''"
                      (input)="onKeyPairChange(i, 'value', $any($event.target).value)" placeholder="Value">
                  </td>
                  <td class="actions-col">
                    <div class="key-value-actions">
                      <button type="button" [disabled]="readonly" class="btn-icon" *ngIf="i === keyPairConfig.length - 1"
                        (click)="addKeyPairInput(i)" title="Add">
                        <svg class="icon" viewBox="0 0 24 24">
                          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
                        </svg>
                      </button>
                      <button type="button" [disabled]="readonly" class="btn-icon btn-danger" *ngIf="keyPairConfig.length > 1"
                        (click)="deleteKeyPair(i)" title="Delete">
                        <svg class="icon" viewBox="0 0 24 24">
                          <path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- JSON View -->
          <div *ngIf="!parameterKeyPair" class="json-section">
            <textarea class="form-textarea json-textarea" [disabled]="readonly" [readonly]="readonly" [(ngModel)]="requestOptions.parameters.json"
              placeholder='{"key": "value"}' rows="8"></textarea>
          </div>
        </div>
        <!-- Authorization Tab -->
        <div class="tab-panel" *ngIf="activeTab === 'authorization' && authRequired">
          <div class="auth-config">
            <div class="form-group">
              <label class="form-label">Authorization Type</label>
              <div class="custom-dropdown" [class.open]="isDropdownOpen('authorizationType')">
                <button type="button" class="custom-dropdown-toggle" [disabled]="readonly" (click)="toggleDropdown('authorizationType', $event)">
                  <span class="custom-dropdown-label" [class.is-placeholder]="!authorizationTypeName">{{ getDropdownLabel(authorizationTypeOptions, authorizationTypeName, 'Select Authorization Type') }}</span>
                  <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                </button>
                <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('authorizationType')">
                  <li class="custom-dropdown-item" *ngFor="let authType of authorizationTypeOptions"
                    [class.active]="authorizationTypeName === authType.id"
                    (click)="onCustomSelect('authorizationType', authType.id, 'authorizationType'); $event.stopPropagation()">
                    {{ authType.name }}
                  </li>
                </ul>
              </div>
            </div>

            <div class="auth-fields">
              <div class="form-group" *ngFor="let field of authorizationTypeData[authorizationTypeName]">
                <label class="form-label">{{ field.label }}</label>
                <input *ngIf="field.type === 'input'" [disabled]="readonly" type="text" class="form-input" [value]="field.value"
                  (input)="onAuthFieldChange(field.keyName, $any($event.target).value)"
                  [type]="field.keyName === 'password' ? 'password' : 'text'">
                <textarea *ngIf="field.type === 'multiLine'" [disabled]="readonly" [readonly]="readonly" class="form-textarea" [value]="field.value"
                  [(ngModel)]="requestOptions.authorisation.json" rows="4"
                  placeholder="Enter token..."></textarea>
              </div>
            </div>
          </div>
        </div>
        <!-- Response Tab -->
        <div class="tab-panel" *ngIf="activeTab === 'response'">
          <div class="form-group switch-group">
            <span class="switch-label">Save API Response</span>
            <div class="property-toggle">
              <label class="switch">
                <input type="checkbox" [disabled]="readonly" [(ngModel)]="isSaveApi"
                  (ngModelChange)="onSaveApiResponseChange($event)">
                <span class="slider round"></span>
              </label>
            </div>
          </div>

          <div *ngIf="isSaveApi" class="response-config">
            <table class="response-table">
              <thead>
                <tr>
                  <th class="field-col">Field</th>
                  <th class="response-key-col">Response Key</th>
                  <th class="actions-col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let config of configs; let i = index">
                  <td class="field-col">
                    <div class="custom-dropdown response-select" [class.open]="isDropdownOpen('responseField-' + i)">
                      <button type="button" [disabled]="readonly" class="custom-dropdown-toggle"
                        (click)="toggleDropdown('responseField-' + i, $event)">
                        <span class="custom-dropdown-label" [class.is-placeholder]="!config.key">{{ getDropdownLabel(getResponseFieldOptions(config), config.key, 'Select Field') }}</span>
                        <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                      </button>
                      <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('responseField-' + i)">
                        <li class="custom-dropdown-item" [class.active]="!config.key"
                          (click)="onCustomSelect('responseField-' + i, '', 'responseField', i); $event.stopPropagation()">
                          Select Field
                        </li>
                        <li class="custom-dropdown-item" *ngFor="let option of getResponseFieldOptions(config)"
                          [class.active]="config.key === option.id"
                          (click)="onCustomSelect('responseField-' + i, option.id, 'responseField', i); $event.stopPropagation()">
                          {{ option.name }}
                        </li>
                      </ul>
                    </div>
                  </td>
                  <td class="response-key-col">
                    <input type="text" [disabled]="readonly" class="form-input response-input" [(ngModel)]="config.value"
                      placeholder="Response Key">
                  </td>
                  <td class="actions-col">
                    <div class="response-actions">
                      <button type="button" [disabled]="readonly" class="btn-icon btn-danger" *ngIf="config.key"
                        (click)="removeItem(config.key!)" title="Remove">
                        <svg class="icon" viewBox="0 0 24 24">
                          <path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z" />
                        </svg>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Non-API Request Form -->
    <div *ngIf="!isAPIRequest" class="non-api-form">
      <div #optionsFormContainer class="options-form-container">
        <div class="form-group" *ngFor="let optionKey of renderedOptionKeys"
          [style.display]="shouldShowField(optionsBasedOnActions[optionKey]) ? 'block' : 'none'">
          <ng-container *ngIf="optionsBasedOnActions[optionKey] as option">
            <label class="form-label" *ngIf="option.type !== 'boolean'">
              {{ option.name || optionKey }}
              <span class="required" *ngIf="option.required || option.is_mandatory">*</span>
            </label>

            <!-- String Input -->
            <input [disabled]="readonly" *ngIf="option.type === 'string' && !option.multi_line" type="text" class="form-input"
              [ngModel]="option.valueToSet || ''" (ngModelChange)="onOptionValueChange(optionKey, $event)"
              [placeholder]="option.placeholder || ('Enter ' + (option.name || optionKey))">

            <!-- Textarea -->
            <textarea [disabled]="readonly" [readonly]="readonly" *ngIf="option.type === 'string' && option.multi_line" class="form-textarea"
              [ngModel]="option.valueToSet || ''" (ngModelChange)="onOptionValueChange(optionKey, $event)"
              [placeholder]="option.placeholder || ('Enter ' + (option.name || optionKey))"
              rows="4"></textarea>

            <!-- Boolean Switch -->
            <div class="switch-group" *ngIf="option.type === 'boolean'">
              <span class="switch-label">{{ option.name || optionKey }}</span>
              <div class="property-toggle">
                <label class="switch">
                  <input [disabled]="readonly" type="checkbox" [ngModel]="option.valueToSet || false"
                    (ngModelChange)="onOptionValueChange(optionKey, $event)">
                  <span class="slider round"></span>
                </label>
              </div>
            </div>

            <!-- List/Dropdown -->
            <ng-container *ngIf="option.type === 'list'">
              <div class="custom-dropdown" [class.open]="isDropdownOpen('list-' + optionKey)"
                [class.disabled]="!!option.loading">
                <button type="button" class="custom-dropdown-toggle" [disabled]="!!option.loading || readonly"
                  (click)="!option.loading && toggleDropdown('list-' + optionKey, $event)">
                  <span class="custom-dropdown-label" [class.is-placeholder]="!getListDropdownDisplayValue(option)">{{ getDropdownLabel(getListDropdownOptions(option), getListDropdownDisplayValue(option), 'Select ' + (option.name || optionKey)) }}</span>
                  <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                </button>
                <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('list-' + optionKey)" (click)="$event.stopPropagation()">
                  <li class="custom-dropdown-item" [class.active]="!getListDropdownDisplayValue(option)"
                    (click)="onCustomSelect('list-' + optionKey, '', 'listOption', optionKey); $event.stopPropagation()">
                    Select {{ option.name || optionKey }}
                  </li>
                  <ng-container *ngFor="let value of getListDropdownOptions(option)">
                    <li class="custom-dropdown-group" *ngIf="value.isGroup">{{ value.name }}</li>
                    <li class="custom-dropdown-item" *ngIf="!value.isGroup"
                      [class.active]="getListDropdownDisplayValue(option) == value.id"
                      (click)="onCustomSelect('list-' + optionKey, value.id, 'listOption', optionKey); $event.stopPropagation()">
                      {{ value.name }}
                    </li>
                  </ng-container>
                </ul>
              </div>

              <!-- Hierarchy child level -->
              <div class="custom-dropdown" style="margin-top: 8px;" *ngIf="option.hierarchyValues?.length"
                [class.open]="isDropdownOpen('hierarchy-' + optionKey)">
                <button [disabled]="readonly" type="button" class="custom-dropdown-toggle" (click)="toggleDropdown('hierarchy-' + optionKey, $event)">
                  <span class="custom-dropdown-label" [class.is-placeholder]="!(option.hierarchySelected || (option.valueToSet && option.valueToSet.toString().indexOf('{{hierarchy.') === 0))">{{ getDropdownLabel(option.hierarchyValues || [], option.hierarchySelected || option.valueToSet || '', 'Select Level') }}</span>
                  <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                </button>
                <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('hierarchy-' + optionKey)" (click)="$event.stopPropagation()">
                  <li class="custom-dropdown-item" [class.active]="!(option.hierarchySelected || (option.valueToSet && option.valueToSet.toString().indexOf('{{hierarchy.') === 0))"
                    (click)="onCustomSelect('hierarchy-' + optionKey, '', 'hierarchy', optionKey); $event.stopPropagation()">
                    Select Level
                  </li>
                  <li class="custom-dropdown-item" *ngFor="let h of option.hierarchyValues"
                    [class.active]="(option.hierarchySelected || option.valueToSet) == h.id"
                    (click)="onCustomSelect('hierarchy-' + optionKey, h.id, 'hierarchy', optionKey); $event.stopPropagation()">
                    {{ h.text || h.name }}
                  </li>
                </ul>
              </div>

              <!-- Managers search (matching old select2 managers_list) -->
              <div class="managers-search-container" *ngIf="option.showManagersSearch" (click)="$event.stopPropagation()">
                <div class="managers-selected-tags" *ngIf="getSelectedManagers(option).length">
                  <div class="managers-tag" *ngFor="let manager of getSelectedManagers(option)">
                    <span>{{ manager.email_address }}</span>
                    <button *ngIf="!readonly" type="button" class="managers-tag-remove" title="Remove"
                      (click)="removeManagerSelection(optionKey, manager._id)">
                      ×
                    </button>
                  </div>
                </div>
                <div class="managers-search-field">
                  <input type="text" class="form-input managers-search-input"
                    [ngModel]="option.managerSearchText || ''"
                    (ngModelChange)="onManagerSearchInput(optionKey, $event)"
                    [disabled]="getSelectedManagers(option).length >= maxManagerSelections || readonly"
                    placeholder="Type and search managers email_address">
                  <div class="managers-search-results" *ngIf="(option.managerSearchResults?.length || option.managerSearching) && (option.managerSearchText || '').length">
                    <div class="form-hint" *ngIf="option.managerSearching">Searching...</div>
                    <ul *ngIf="!option.managerSearching">
                      <li *ngFor="let manager of option.managerSearchResults"
                        (click)="addManagerSelection(optionKey, manager)">
                        {{ manager.email_address }}
                      </li>
                      <li class="managers-no-results" *ngIf="!(option.managerSearchResults?.length)">
                        No managers found
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="form-hint managers-note">Note: Maximum of {{ maxManagerSelections }} manager selections are allowed.</div>
              </div>

              <div *ngIf="option.loading" class="form-hint">Loading options...</div>
            </ng-container>

            <!-- Object/Key-Value editable -->
            <div *ngIf="option.type === 'object'" class="object-input-section">
              <button type="button" [disabled]="readonly" class="btn btn-secondary btn-sm" (click)="addObjectKeyValue(optionKey)">Add</button>
              <div class="key-value-row" *ngFor="let kv of option.keyValuePairs; let ki = index">
                <input [disabled]="readonly" type="text" class="form-input key-input" [ngModel]="kv.key"
                  (ngModelChange)="onObjectKeyValueChange(optionKey, ki, 'key', $event)" placeholder="Key">
                <input  [disabled]="readonly"type="text" class="form-input value-input" [ngModel]="kv.value"
                  (ngModelChange)="onObjectKeyValueChange(optionKey, ki, 'value', $event)" placeholder="Value">
                <button [disabled]="readonly" type="button" class="btn-icon btn-danger" *ngIf="(option.keyValuePairs?.length || 0) > 1"
                  (click)="deleteObjectKeyValue(optionKey, ki)" title="Delete">
                  <svg class="icon" viewBox="0 0 24 24">
                    <path d="M19 4h-3.5l-1-1h-5l-1 1H5v2h14M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12z" />
                  </svg>
                </button>
              </div>
            </div>

            <!-- Component type: email / SMS / WhatsApp template pickers -->
            <ng-container *ngIf="option.type === 'component'">
              <div class="template-picker" [class.loading]="!!option.templateLoading">
                <!-- Email: upload + dropdown + preview/download -->
                <div class="template-picker-controls" *ngIf="option.templateComponentType === 'email'">
                  <label class="template-upload-btn" title="Upload HTML template">
                    <input [disabled]="readonly" type="file" accept="text/html,.html" hidden
                      (change)="onTemplateFilePick(optionKey, $event)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18">
                      <path fill="currentColor" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15h8v2H8v-2zm0-4h8v2H8v-2z"/>
                    </svg>
                  </label>
                  <div class="custom-dropdown template-dropdown" [class.open]="isDropdownOpen('template-' + optionKey)">
                    <button type="button" class="custom-dropdown-toggle" [disabled]="!!option.templateLoading || readonly"
                      (click)="!option.templateLoading && toggleDropdown('template-' + optionKey, $event)">
                      <span class="custom-dropdown-label" [class.is-placeholder]="!option.valueToSet">{{ getDropdownLabel(getTemplateDropdownOptions(option), option.valueToSet, 'Pick a Template') }}</span>
                      <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                    </button>
                    <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('template-' + optionKey)" (click)="$event.stopPropagation()">
                      <li class="custom-dropdown-item" [class.active]="!option.valueToSet"
                        (click)="onCustomSelect('template-' + optionKey, '', 'template', optionKey); $event.stopPropagation()">
                        Pick a Template
                      </li>
                      <li class="custom-dropdown-item" *ngFor="let t of getTemplateDropdownOptions(option)"
                        [class.active]="option.valueToSet == t.id"
                        (click)="onCustomSelect('template-' + optionKey, t.id, 'template', optionKey); $event.stopPropagation()">
                        {{ t.name }}
                      </li>
                    </ul>
                  </div>
                  <button type="button" class="template-icon-btn" title="Preview" [disabled]="!option.valueToSet"
                    (click)="previewEmailTemplate(optionKey)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18">
                      <path fill="currentColor" d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                    </svg>
                  </button>
                  <button type="button" class="template-icon-btn" title="Download" [disabled]="!option.valueToSet"
                    (click)="downloadEmailTemplate(optionKey)">
                    <svg class="icon" viewBox="0 0 24 24" width="18" height="18">
                      <path fill="currentColor" d="M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"/>
                    </svg>
                  </button>
                </div>

                <!-- SMS / WhatsApp: dropdown + preview textarea -->
                <ng-container *ngIf="option.templateComponentType === 'sms' || option.templateComponentType === 'whatsapp'">
                  <div class="custom-dropdown template-dropdown" [class.open]="isDropdownOpen('template-' + optionKey)">
                    <button type="button" class="custom-dropdown-toggle" [disabled]="!!option.templateLoading || readonly"
                      (click)="!option.templateLoading && toggleDropdown('template-' + optionKey, $event)">
                      <span class="custom-dropdown-label" [class.is-placeholder]="!option.valueToSet">{{ getDropdownLabel(getTemplateDropdownOptions(option), option.valueToSet, 'Pick a Template') }}</span>
                      <img class="custom-dropdown-caret" src="assets/images/down-arrow.svg" alt="" />
                    </button>
                    <ul class="custom-dropdown-menu" *ngIf="isDropdownOpen('template-' + optionKey)" (click)="$event.stopPropagation()">
                      <li class="custom-dropdown-item" [class.active]="!option.valueToSet"
                        (click)="onCustomSelect('template-' + optionKey, '', 'template', optionKey); $event.stopPropagation()">
                        Pick a Template
                      </li>
                      <li class="custom-dropdown-item" *ngFor="let t of getTemplateDropdownOptions(option)"
                        [class.active]="option.valueToSet == t.id"
                        (click)="onCustomSelect('template-' + optionKey, t.id, 'template', optionKey); $event.stopPropagation()">
                        {{ t.name }}
                      </li>
                      <li class="custom-dropdown-item custom-dropdown-empty"
                        *ngIf="!option.templateLoading && !(option.templateOptions?.length)">
                        No templates available
                      </li>
                    </ul>
                  </div>
                  <textarea class="form-textarea template-preview" rows="5" readonly
                    [placeholder]="(option.templateComponentType === 'sms' ? 'SMS' : 'WhatsApp') + ' Template Preview'"
                    [ngModel]="option.templatePreviewText || ''"></textarea>
                </ng-container>

                <div *ngIf="option.templateLoading" class="form-hint">Loading templates...</div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Business Hours Toggle -->
    <div class="form-group switch-group business-hour-toggle" *ngIf="isBusinessHourSetup">
      <span class="switch-label">Perform action during Business Hours only</span>
      <div class="property-toggle">
        <label class="switch">
            <input type="checkbox" [disabled]="readonly" [(ngModel)]="performActionOnBusinessHour"
            (ngModelChange)="changeIsBusinessHour($event)">
          <span class="slider round"></span>
        </label>
      </div>
    </div>



    <!-- Action Buttons -->
    <div class="form-actions" *ngIf="!readonly">
      <button type="button" class="btn btn-primary" (click)="addAction()">
        {{ actionIndexToUpdate !== null ? 'Update' : 'Add' }} Action
      </button>
      <button type="button" class="btn btn-secondary" (click)="resetForm()">
        Cancel
      </button>
    </div>
  </div>
  </div>
 
</div>
